import { render, staticRenderFns } from "./order-list.vue?vue&type=template&id=bd067240&scoped=true&"
import script from "./order-list.vue?vue&type=script&lang=js&"
export * from "./order-list.vue?vue&type=script&lang=js&"
import style0 from "./order-list.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./order-list.vue?vue&type=style&index=1&id=bd067240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd067240",
  null
  
)

export default component.exports